import React from "react";
import { useSelector } from "react-redux";
import NavBar from "../components/NavBar";
import {
  SideMenu,
  SideMenuItem,
  SideMenuItemGroup,
} from "../components/SideMenu";
import { controlConstants } from "../constants/controlConstants";

export default function SystemParticipant(props) {
  let { location, t } = props;
  const sidemenu = useSelector((state) => state.utilities.sidemenu);
  const authUser = useSelector((state) => state.authorization.user);

  let routeGroup = {
    organizedMarketOperations: [
      "/offer-operations",
      "/offerOperations-notAllowed",
      "/market-results",
      "/offers-and-matches",
      "/objections",
    ],
    marketOperations: [
      "/active-certificates",
      "/active-certificates-notAllowed",
      "/suspended-certificates",
      "/suspended-certificates-notAllowed",
      "/canceled-certificates",
      "/canceled-certificates-notAllowed",
      "/export-transactions",
      "/export-transactions-notAllowed",
      "/redemption-operations",
      "/redemption-operations-notAllowed",
      "/redemption-operations-history",
      "/bilateral-agreements",
      "/bilateral-agreements-notAllowed",
      "/bilateral-agreement-operations",
      "/gddk-operations",
      "/gddk-operations/production-data",
      "/gddk-operations/consumption-data",
    ],
    reconciliation: ["/reconciliation"],
    invoicing: ["/invoicing"],
    systemParameters: ["/system-paramters"],
    collateralOperations: [
      "/intra-seance-collateral",
      "/invoice-colletarel-report",
    ],
  };
  const routeIsActive = (route) => {
    if (route === "homepage") {
      return location.pathname === "/";
    }
    return routeGroup[route].includes(location.pathname);
  };

  return (
    <div className="km__l--default-container">
      <NavBar user={{ name: authUser.username }} t={t} />
      <SideMenu>
        <SideMenuItemGroup
          icon="dashboard"
          label={t("ui.default.sideMenu.homepage")}
          isActive={routeIsActive("homepage")}
        >
          <SideMenuItem
            to="/"
            label={t("ui.default.sideMenu.homepage")}
            exact
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="organized-market"
          label={t("ui.default.sideMenu.organizedMarketOperations")}
          isActive={routeIsActive("organizedMarketOperations")}
        >
          {authUser.organization.marketParticipationAgreement ? (
            <>
              {authUser.organization.yekgOrganizationStatus ===
                controlConstants?.PASSIVE ||
              authUser.organization.yekgOrganizationStatus ===
                controlConstants?.PARTIAL_PASSIVE ? (
                <SideMenuItem
                  to="/offer-operations-notAllowed"
                  label={t("ui.default.sideMenu.offerOperations")}
                />
              ) : (
                <SideMenuItem
                  to="/offer-operations"
                  label={t("ui.default.sideMenu.offerOperations")}
                />
              )}

              <SideMenuItem
                to="/offers-and-matches"
                label={t("ui.default.sideMenu.offersAndMatches")}
              />
              <SideMenuItem
                to="/market-results"
                label={t("ui.default.sideMenu.marketResults")}
              />
              <SideMenuItem
                to="/objections"
                label={t("ui.default.sideMenu.objections")}
              />
            </>
          ) : null}
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="certificates"
          label={t("ui.default.sideMenu.marketOperations")}
          isActive={routeIsActive("marketOperations")}
        >
          {authUser.organization.yekgOrganizationStatus ===
          controlConstants?.PASSIVE ? (
            <SideMenuItem
              to="/active-certificates-notAllowed"
              label={t("ui.default.sideMenu.activeCertificates")}
            />
          ) : (
            <SideMenuItem
              to="/active-certificates"
              label={t("ui.default.sideMenu.activeCertificates")}
            />
          )}
          {authUser.organization.yekgOrganizationStatus ===
          controlConstants?.PASSIVE ? (
            <SideMenuItem
              to="/suspended-certificates-notAllowed"
              label={t("ui.default.sideMenu.suspendedCertificates")}
            />
          ) : (
            <SideMenuItem
              to="/suspended-certificates"
              label={t("ui.default.sideMenu.suspendedCertificates")}
            />
          )}
          {authUser.organization.yekgOrganizationStatus ===
          controlConstants?.PASSIVE ? (
            <SideMenuItem
              to="/canceled-certificates-notAllowed"
              label={t("ui.default.sideMenu.canceledCertificates")}
            />
          ) : (
            <SideMenuItem
              to="/canceled-certificates"
              label={t("ui.default.sideMenu.canceledCertificates")}
            />
          )}
          {authUser.organization.yekgLicenseType !== controlConstants.RETAIL &&
          authUser.organization.yekgLicenseType !== controlConstants.K1 &&
          authUser?.organization?.licenseType !==
            controlConstants?.CHARGING_NETWORK_OPERATOR ? (
            authUser.organization.yekgOrganizationStatus ===
              controlConstants?.PARTIAL_PASSIVE ||
            authUser.organization.yekgOrganizationStatus ===
              controlConstants?.PARTIAL_PASSIVE ? (
              <SideMenuItem
                to="/export-transactions-notAllowed"
                label={t("ui.default.sideMenu.exportTransactions")}
              />
            ) : (
              <SideMenuItem
                to="/export-transactions"
                label={t("ui.default.sideMenu.exportTransactions")}
              />
            )
          ) : null}
          {authUser.organization.yekgOrganizationStatus ===
            controlConstants?.PASSIVE ||
          authUser.organization.yekgOrganizationStatus ===
            controlConstants?.PARTIAL_PASSIVE ? (
            <SideMenuItem
              to="/redemption-operations-notAllowed"
              label={t("ui.default.sideMenu.redemptionOperations")}
            />
          ) : (
            <SideMenuItem
              to="/redemption-operations"
              label={t("ui.default.sideMenu.redemptionOperations")}
            />
          )}
          <SideMenuItem
            to="/redemption-operations-history"
            label={t("ui.default.sideMenu.redemptionOperationsHistory")}
          />
          {authUser.organization.yekgOrganizationStatus ===
            controlConstants?.PASSIVE ||
          authUser.organization.yekgOrganizationStatus ===
            controlConstants?.PARTIAL_PASSIVE ? (
            <SideMenuItem
              to="/bilateral-agreements-notAllowed"
              label={t("ui.default.sideMenu.bilateralAgreements")}
            />
          ) : (
            <SideMenuItem
              to="/bilateral-agreements"
              label={t("ui.default.sideMenu.bilateralAgreements")}
            />
          )}
          <SideMenuItem
            to="/bilateral-agreement-operations"
            label={t("ui.default.sideMenu.bilateralAgreementOperations")}
          />
          {!authUser.organization?.pastCommitment ? (
            ""
          ) : (
            <SideMenuItem
              to="/gddk-operations"
              label={t("ui.default.sideMenu.gddkOperations")}
            />
          )}
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="reconcilliation"
          label={t("ui.default.sideMenu.reconciliation")}
          isActive={routeIsActive("reconciliation")}
        >
          <SideMenuItem
            to="/reconciliation"
            label={t("ui.default.sideMenu.reconciliation")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="refresh-ccw"
          label={t("ui.default.sideMenu.collateralOperations")}
          isActive={routeIsActive("collateralOperations")}
        >
          <SideMenuItem
            to="/intra-seance-collateral"
            label={t("ui.default.sideMenu.intraSeanceCollateral")}
          />
          <SideMenuItem
            to="/invoice-colletarel-report"
            label={t("ui.default.sideMenu.invoiceColletarelReport")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="invoicing"
          label={t("ui.default.sideMenu.invoicing")}
          isActive={routeIsActive("invoicing")}
        >
          <SideMenuItem
            to="/invoicing"
            label={t("ui.default.sideMenu.invoicing")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="parameters"
          label={t("ui.default.sideMenu.systemParameters")}
          isActive={routeIsActive("systemParameters")}
        >
          <SideMenuItem
            to="/system-parameters"
            label={t("ui.default.sideMenu.systemParameters")}
          />
        </SideMenuItemGroup>
      </SideMenu>
      <div
        className={`km__l--default-content-container ${
          sidemenu ? "km__l--default-content-container-is-sidemenu-active" : ""
        }`}
      >
        <div className="km__l--default-content">{props.children}</div>
      </div>
    </div>
  );
}
